<template>
  <div class="supplement-record">
    <gj-alert style="padding: 12px 0;" type="warning" :title="titleMsg" show-icon></gj-alert>
    <el-form ref="form" :model="form" class="form-content">
      <gj-table
        ref="gjTable"
        size="has-picture"
        name="flag"
        :index="false"
        :data="form.tableData"
        :columns="columns"
        :show-overflow="false"
        :loading="loading.table"
        :offsetHeight="48"
        :structure-config="{type: 'ParentChild', children: 'itemList', parentSpan: [0, 7]}">
        <template v-slot:header:shipDate>
          <span style="color: red">*&nbsp;</span>发货日期
        </template>
        <template v-slot:header:shipQuantity>
          <span style="color: red">*&nbsp;</span>补录数量
        </template>
        <template v-slot:header:purchaseCost>
          <span style="color: red">*&nbsp;</span>单个采购成本
        </template>
        <template v-slot:header:arrivalCost>
          <span style="color: red">*&nbsp;</span>单个到库成本
        </template>
        <template #dataIndex="{row}">
          <template v-if="row.$gjParentData">
            <div class="flex justify-between align-center">
              <div class="flex align-center" style="flex:1">
                <div class="flex align-center" style="width: 17.2%;">
                  <gj-image :src="row.smallImageUrl"></gj-image>
                  <span class="gj-ml12">MSKU:<gj-tooltip :content="row.msku" :text-line="1">{{row.msku | defaultShow}}</gj-tooltip></span>
                </div>
                <div style="width: 17.5%;">
                  货件号：{{row.shipmentId | defaultShow}}
                </div>
                <div style="width: 17.5%;">
                  仓库：{{row.warehouseName | defaultShow}}
                </div>
                <div>
                  <div>申报量：{{row.quantityShipped | defaultShow}}</div>
                  <div>收货量：{{row.quantityReceived | defaultShow}}</div>
                </div>
              </div>
              <div style="width: 10.2%;">
                <i class="el-icon-circle-plus-outline size18" v-if="row.itemList.length === 0" @click="addChildRow(row)"></i>
              </div>
            </div>
          </template>
          <template v-else>
            {{row.dataIndex+1}}
          </template>
        </template>
        <template #batchNumber="{row}">
          <template>
            <span class="gj-mr12">{{row.batchNumber | defaultShow}}</span><gj-tag v-if="isMeaningful(row.id)" :color="tagColors.orange" type="plain">历史补录</gj-tag>
          </template>
        </template>
        <template #shipDate="{row}">
          <el-form-item
            :prop="`tableData.${row.parentIndex}.itemList.${row.dataIndex}.shipDate`"
            :rules="[
              { required: true, message: '请选择发货日期', trigger: ['blur', 'change']}
            ]">
            <gj-date-picker
              v-model="row.shipDate"
              type="date"
              width="80%"
              placeholder="请选择">
            </gj-date-picker>
          </el-form-item>
        </template>
        <template #shipQuantity="{row}">
          <el-form-item
            :prop="`tableData.${row.parentIndex}.itemList.${row.dataIndex}.shipQuantity`"
            :rules="[
              { required: true, message: '请输入发货数量', trigger: ['blur', 'change']},
              $gjReRule(RE.pt, '请输入大于0的整数')
            ]">
            <gj-input maxlength="8" v-model="row.shipQuantity" @blur="onShipQuantityBlur($event, row)" width="95%"></gj-input>
          </el-form-item>
        </template>
        <!-- 单个采购成本 -->
        <template #purchaseCost="{ row }">
          <el-form-item
            :prop="`tableData.${row.parentIndex}.itemList.${row.dataIndex}.purchaseCost`"
            :rules="[
              { required: true, message: '请输入单个采购成本', trigger: ['blur', 'change']},
              $gjReRule(RE.num(4), '最多四位小数的正数'),
            ]">
            <gj-input maxlength="10" v-model="row.purchaseCost" width="95%">
              <template #prepend>￥</template>
            </gj-input>
          </el-form-item>
        </template>
        <!-- 单个到库成本 -->
        <template #arrivalCost="{ row }">
          <el-form-item
            :prop="`tableData.${row.parentIndex}.itemList.${row.dataIndex}.arrivalCost`"
            :rules="[
              { required: true, message: '请输入单个到库成本', trigger: ['blur', 'change'] },
              $gjReRule(RE.num(4), '最多四位小数的正数'),
            ]">
            <gj-input maxlength="10" v-model="row.arrivalCost" width="95%">
              <template #prepend>￥</template>
            </gj-input>
          </el-form-item>
        </template>
        <!--操作 -->
        <template #op="{ row }">
          <div class="flex align-center justify-between" style="width: 50px;">
            <i class="el-icon-circle-plus-outline size18" v-if="!isMeaningful(row.id) && row.dataIndex + 1 === form.tableData[row.parentIndex].itemList.length" @click="addRow(row)"></i>
            <i class="el-icon-remove-outline size18" @click="deleteRow(row)"></i>
          </div>
        </template>
      </gj-table>
      <div class="opt">
        <gj-button @click="cancel">取消</gj-button>
        <gj-button type="primary" :loading="loading.confirm" @click="confirm">确认</gj-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { formRuleMixin, isMeaningfulMixin } from "@/minxins";
import { isMeaningful } from "@/utils/common";
import { supplementHistory, saveOrUpdateOrDelete } from "@/api/finance";
import { tagColors } from '@/components/tag/tag-colors';
import { convertToDate } from "@/utils/date.util"
import BigNumber from 'bignumber.js';

export default {
  name: "ReplacementCost",
  inject: ["getPublicData", "setPublicData"],
  mixins: [formRuleMixin, isMeaningfulMixin],
  computed: {
    publicData() {
      return this.getPublicData()
    }
  },
  created() {
    this.supplementHistory()
  },
  data() {
    return {
      loading: {
        confirm: false,
        table: false,
      },
      titleMsg: "确认补录后，系统将自动重算扣减记录，对于销售-利润统计、财务-利润报表将在凌晨进行自动重算，如需立即生效，请在相应页面进行手动重算。",
      form: {
        tableData: []
      },
      columns: [
        { id: 'dataIndex', header: '序号', field: 'slot:dataIndex', minWidth: '150px',},
        { id: 'batchNumber', header: '批次号', field: 'slot:batchNumber', minWidth: '150px', },
        { id: 'shipDate', header: 'slot:shipDate', field: 'slot:shipDate', minWidth: '150px', },
        { id: 'shipQuantity', header: 'slot:shipQuantity', field: 'slot:shipQuantity', minWidth: '140px', },
        { id: 'purchaseCost', header: 'slot:purchaseCost', field: 'slot:purchaseCost', minWidth: '120px',},
        { id: 'arrivalCost', header: 'slot:arrivalCost', field: 'slot:arrivalCost', minWidth: '120px', },
        { id: 'op', header: '操作', field: 'slot:op', minWidth: '80px', notCustomColumn: true, fixed: "right" },
      ],
      tagColors,
      deleteIdList: []
    };
  },
  methods: {
    // 1.10.2-发货补录历史列表查询
    supplementHistory() {
      this.loading.table = true
      let params = []
      this.publicData.selectList.forEach(item => {
        let obj = (({smallImageUrl,msku,shipmentId,warehouseName,warehouseId,quantityReceived,quantityShipped}) => ({smallImageUrl,msku,shipmentId,warehouseName,warehouseId,quantityReceived,quantityShipped}))(item)
        params.push(obj)
      })
      // 带这么多参数的原因,保证在查询不到数据时,接口可以及时将父级数据返回,也保证数据来源的统一性
      supplementHistory(params).then(data => {
        let list = data || []
        list.forEach((items, indexs) => {
          items.index = indexs
          if(isMeaningful(items.itemList)) {
            items.itemList.forEach((item, index) => {
              item.dataIndex = index
              item.parentIndex = indexs
            })
            items.itemList.push({
              dataIndex: items.itemList.length,
              id: null,
              batchNumber: '',
              shipDate: '',
              shipQuantity: '',
              purchaseCost: '',
              arrivalCost: '',
              parentIndex: indexs
            })
          } else {
            items.itemList = []
            items.itemList.push({
              dataIndex: items.itemList.length,
              id: null,
              batchNumber: '',
              shipDate: '',
              shipQuantity: '',
              purchaseCost: '',
              arrivalCost: '',
              parentIndex: indexs
            })
          }
          items.itemListCopy = items.itemList || []
          items.expand = false
        })
        this.form.tableData = list
      }).complete(() => { this.loading.table = false })
    },
    addChildRow(row) {
      let dataIndex = this.form.tableData[row.index].itemList.length
      this.form.tableData[row.index].itemList.push({
        dataIndex: dataIndex,
        id: null,
        batchNumber: '',
        shipDate: '',
        shipQuantity: '',
        purchaseCost: '',
        arrivalCost: '',
        parentIndex: row.index
      })
    },
    // 新增
    addRow(row) {
      let dataIndex = this.form.tableData[row.parentIndex].itemList.length
      this.form.tableData[row.parentIndex].itemList.push({
        dataIndex: dataIndex,
        id: null,
        batchNumber: '',
        shipDate: '',
        shipQuantity: '',
        purchaseCost: '',
        arrivalCost: '',
        parentIndex: row.parentIndex
      })
    },
    // 移除
    deleteRow(row) {
      if(isMeaningful(row.id)) {
        const modal = this.$gjCreate('gj-info-modal', {
            props: {
                title: '确认删除？',
                content: `<div>该操作将在提交本次补录时删除该历史补录数据，请确认是否删除？<div>
                <div class="color666 size12 gj-mt12">删除影响：补录批次的数量及成本、扣减纪录、利润统计及利润报表，确认删除系统将在凌晨重算扣
减及利润。</div>`
            },
            on: {
                cancel: () => modal.$gjDestroy(),
                confirm: () => {
                    modal.$gjDestroy()
                    this.deleteIdList.push(row.id)
                    this.form.tableData[row.parentIndex].itemList.splice(row.dataIndex, 1)
                    this.form.tableData[row.parentIndex].itemList.forEach((item, index) => item.dataIndex = index)
                }
            }
        })
      }else {
        this.form.tableData[row.parentIndex].itemList.splice(row.dataIndex, 1)
        this.form.tableData[row.parentIndex].itemList.forEach((item, index) => item.dataIndex = index)
      }
    },
    // 补发数量校验
    onShipQuantityInput(ev, row) {
      let total = Number(this.form.tableData[row.parentIndex].quantityReceived)
      let shipQuantityTotal = 0
      this.form.tableData[row.parentIndex].itemList.forEach(item=> {
        shipQuantityTotal += Number(item.shipQuantity || 0)
      })
      if(shipQuantityTotal>total){
        this.$gjMessage.warning('补发数量总和不能超过货件收货量!')
        let maxShipQuantity = total - (shipQuantityTotal - Number(ev))
        this.form.tableData[row.parentIndex].itemList[row.dataIndex].shipQuantity = maxShipQuantity < 0 ? 0 : maxShipQuantity
      }
    },
    onShipQuantityBlur(ev, row){
      let total = Number(this.form.tableData[row.parentIndex].quantityReceived)
      let shipQuantityTotal = 0
      this.form.tableData[row.parentIndex].itemList.forEach(item=> {
        shipQuantityTotal += Number(item.shipQuantity || 0)
      })
      if(shipQuantityTotal>total){
        this.$gjMessage.warning('补发数量总和不能超过货件收货量!')
        let maxShipQuantity = total - (shipQuantityTotal - Number(ev.target.value))
        ev.target.value = maxShipQuantity < 0 ? 0 : maxShipQuantity
      }
    },
    // 修改单个采购成本/总单个到库成本
    changeSingle(type, row, ev) {
      row[type] = new BigNumber(ev).times(row.receiptQuantity).decimalPlaces(4) + ''
    },
    // 取消
    cancel() {
      this.setPublicData('state', 'delivery-supplement')
    },
    // 确定
    confirm() {
      this.loading.confirm = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          let table = this.form.tableData
          for(let i = 0; i < table.length; i++) {
            let items = table[i]
            let shipQuantityTotal = 0
            items.itemList.forEach(item=> {
              shipQuantityTotal += Number(item.shipQuantity)
            })
            if(shipQuantityTotal>items.quantityReceived){
              this.$gjMessage.error(`补发数量总和不能超过货件收货量,请调整${items.shipmentId}货件的补录数据`)
              return false
            }
          }
          if(this.deleteIdList.length > 0) {
            const modal = this.$gjCreate('gj-info-modal', {
                props: {
                    title: '温馨提示',
                    content: `历史补录被删除,请确认是否提交？`
                },
                on: {
                    cancel: () => modal.$gjDestroy(),
                    confirm: () => {
                        modal.$gjDestroy()
                        this.saveOrUpdateOrDelete();
                    }
                }
            })
          } else {
            this.saveOrUpdateOrDelete();
          }
        } else {
          this.$gjMessage.error("请完善数据");
          this.loading.confirm = false
          return false;
        }
      });
    },
    // 或修改或删除发货补录信息
    saveOrUpdateOrDelete() {
      const saveOrUpdateDTOList = []
      let table = this.form.tableData
      table.forEach(items => {
        items.itemList.forEach(item => {
          saveOrUpdateDTOList.push({
            arrivalCost: item.arrivalCost,
            arrivalCurrency: '￥',
            id: item.id,
            memo: item.memo || '',
            msku: items.msku,
            purchaseCost: item.purchaseCost,
            purchaseCurrency: '￥',
            recalculate: true,
            shipDate: convertToDate(item.shipDate),
            shipQuantity: item.shipQuantity,
            shipmentId: items.shipmentId,
            warehouseId: items.warehouseId || 0
          })
        })
      })
      let params = {
        deleteIdList: this.deleteIdList,
        saveOrUpdateDTOList
      }
      saveOrUpdateOrDelete(params).then(res => {
         this.$gjMessage.success("操作成功")
         this.$emit("cancel");
      }).complete(()=>{ this.loading.confirm = false });
    }
  },
};
</script>

<style scoped lang="scss">
.supplement-record {
  // padding-top: 12px;
}
/deep/.form-content {
  .vxe-table--body {
    .vxe-body--row {
      .vxe-body--column {
        height: 54px !important;
        .el-form-item {
          margin: 8px 0 10px;
          position: relative;
        }
        .el-form-item__error {
          position: absolute;
          top: auto;
          bottom: -13px;
          left: 0;
          white-space: initial;
        }
      }
    }
  }
}
.opt {
  padding-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
